module.exports = __webpack_public_path__ + "img/pethouse02.9e029525.jpg";